export default __webpack_public_path__ + "static/media/480_business05-it-mobile.55b985c6.png";